import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as _ from '../../lodash';
import inputParser from '../../../components/components/widget/input_parser';
import { onDurationOptionSet } from '../../../components/actions/product.js';

const parseDefaultValue = (field) => {
  // {\"type\":\"dropdown\",\"label\":\"dfdfd\",\"key\":\"_dfdfd\",\"options\":[\"aaa\"]}
  switch (field.type) {
    case 'dropdown':
    case 'radio':
    case 'checkbox':
      return { defaultValue: field.options, currentValue: field.value };
    default:
      return { defaultValue: '', currentValue: field.value };
  }
};

export default class BookingFieldsBlock extends Component {
  render() {
    const { bookingFields, onChange } = this.props;
    return (
      <div className="block">
        {bookingFields.map((field) => {
          const { key, type } = field;
          const { defaultValue, currentValue } = parseDefaultValue(field);
          const dom = inputParser({
            type,
            key,
            onChange,
            defaultSetting: { [key]: defaultValue },
            currentSetting: { [key]: currentValue },
          });

          return (
            <div className="pure-g mt15" key={key}>
              <div className="pure-u-1-3">
                <label className="control-label">{field.label}</label>
              </div>
              <div className="pure-u-1-3">{dom}</div>
            </div>
          );
        })}
      </div>
    );
  }
}

BookingFieldsBlock.propTypes = {
  bookingFields: PropTypes.array.isRequired,
  onChange: PropTypes.func,
};
